import { ChannelIcon, type ChannelType, Text } from '@buffer-mono/popcorn'
import clsx from 'clsx'
import type { Service } from '~publish/gql/graphql'
import { capitalize } from '~publish/helpers/capitalize'
import styles from './ChannelServiceTag.module.css'

export const ChannelServiceTag = ({
  service,
}: {
  service: Service
}): JSX.Element => {
  return (
    <Text
      key={service}
      className={clsx(styles.channelTag)}
      data-channel={service}
    >
      <ChannelIcon type={service as ChannelType} color="inverted" size={14} />
      {capitalize(service)}
    </Text>
  )
}
